const tableTitleVerification = {
  title: 'Checklist Groups',
  placeholder: 'Search by checklist groups',
  Typography: 'No results found'
};

export default tableTitleVerification;

